import React, { FC, useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import IconDS22 from '../../../common/components/IconDS22';
import ToggleDecorator from '../../../common/components/ToggleDecorator';

import styles from './ToggleMap.module.scss';

export type Props = {
  value: boolean;
  onToggle: (toggle: boolean | undefined) => void;
  disabled?: boolean;
};

const ToggleMap: FC<Props> = ({ onToggle, value, disabled }) => {
  const [t] = useTranslation('search-page');

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(event?.target?.checked);
  }, [onToggle]);

  return (
    <div className={styles.root}>
      <label
        className={styles.mapViewIcon}
        htmlFor="map-toggle"
      >
        <IconDS22
          id="map"
          size="xl"
        />
        {t('map-toggle--map-view')}
      </label>

      <ToggleDecorator>
        <input
          id="map-toggle"
          checked={value}
          type="checkbox"
          onChange={handleChange}
          disabled={disabled}
        />
      </ToggleDecorator>

    </div>
  );
};

export default ToggleMap;
